export const roundToTwoDecimals = (num) => {
  return Math.round(num * 100) / 100;
};
